// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import {fmt_money} from '../../utils/misc.js';
import {Icon} from '../../comp/icon';
import {Text} from '../text';
import * as cns from './money.module.less';

const ICO_SIZE_MAP = {
    s: 's',
    m: 'm',
    l: 'l',
};

export function Money({className, children, size='m'}){
    const ch_type = typeof children;
    const content = ch_type=='string' || ch_type=='number'
        ? fmt_money(children)
        : children;
    const Comp = Text[size] || Text.m;
    const ico_size = ICO_SIZE_MAP[size] || 'l';
    return <div className={cn(cns.root, className)}>
      <Icon className={cns.ico} size={ico_size} ico="money" color="accent"/>
      <Comp className={cns.value} mono>{content}</Comp>
    </div>;
}
